module.exports = __webpack_public_path__ + "img/cpanni.645317e5.jpg";